import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table align-middle table-sm table-prima" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = { class: "d-flex justify-content-between" }
const _hoisted_7 = { class: "d-flex justify-content-between" }
const _hoisted_8 = { class: "d-flex justify-content-between" }
const _hoisted_9 = {
  class: "flex-grow-1 text-center ps-2 th-icon th-icon-pkg",
  title: "Licencia de Distribuidor"
}
const _hoisted_10 = { class: "text-center text-nowrap" }
const _hoisted_11 = { class: "d-flex justify-content-between" }
const _hoisted_12 = { class: "text-center text-nowrap" }
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = { class: "text-center text-nowrap" }
const _hoisted_15 = { class: "d-flex justify-content-between" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "d-flex justify-content-between" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "pe-1 overflow-hidden" }
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = { class: "d-flex align-items-center position-relative flex-grow-1 text-nowrap" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "leader-name position-relative w-100 lh-1 ps-2 small" }
const _hoisted_25 = { class: "d-flex flex-column" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "small text-muted" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "d-flex align-items-center small" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-center mt-3 d-flex flex-column align-items-center gap-1 small" }
const _hoisted_35 = ["title"]
const _hoisted_36 = { class: "small" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "text-center mt-3 d-flex flex-column align-items-center small" }
const _hoisted_39 = { class: "text-center align-top" }
const _hoisted_40 = { class: "small lh-1 my-1" }
const _hoisted_41 = { class: "small fw-bold" }
const _hoisted_42 = { class: "small text-nowrap" }
const _hoisted_43 = { class: "text-center align-top" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "small lh-1 my-1" }
const _hoisted_47 = { class: "small fw-bold" }
const _hoisted_48 = { class: "small text-nowrap" }
const _hoisted_49 = { class: "text-center align-top" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "small lh-1 my-1" }
const _hoisted_52 = { class: "small fw-bold" }
const _hoisted_53 = { class: "small text-nowrap" }
const _hoisted_54 = { class: "d-flex flex-column align-items-stretch" }
const _hoisted_55 = { class: "fw-bold border-bottom text-center" }
const _hoisted_56 = { class: "small d-flex text-center" }
const _hoisted_57 = { class: "w-50 d-flex border-end lh-1" }
const _hoisted_58 = {
  key: 0,
  class: "d-flex align-items-center ms-1"
}
const _hoisted_59 = { class: "flex-fill mt-1" }
const _hoisted_60 = { class: "text-nowrap flex-fill ms-1 small" }
const _hoisted_61 = { class: "w-50 d-flex lh-1" }
const _hoisted_62 = { class: "flex-fill mt-1" }
const _hoisted_63 = { class: "text-nowrap flex-fill ms-1 small" }
const _hoisted_64 = {
  key: 0,
  class: "d-flex align-items-center me-1"
}
const _hoisted_65 = { class: "d-flex flex-column align-items-stretch" }
const _hoisted_66 = { class: "fw-bold text-center" }
const _hoisted_67 = { class: "d-flex flex-column align-items-stretch" }
const _hoisted_68 = { class: "fw-bold border-bottom text-center" }
const _hoisted_69 = { class: "small d-flex text-center mb-3" }
const _hoisted_70 = { class: "w-50 d-flex border-end lh-1 pt-1" }
const _hoisted_71 = {
  key: 0,
  class: "d-flex align-items-center ms-1"
}
const _hoisted_72 = { class: "flex-fill" }
const _hoisted_73 = { class: "w-50 d-flex lh-1 pt-1" }
const _hoisted_74 = { class: "flex-fill" }
const _hoisted_75 = {
  key: 0,
  class: "d-flex align-items-center me-1"
}
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_team_users_sort = _resolveComponent("my-team-users-sort")!
  const _component_my_team_numeric_sort = _resolveComponent("my-team-numeric-sort")!
  const _component_my_team_alpha_sort = _resolveComponent("my-team-alpha-sort")!
  const _component_package_icon = _resolveComponent("package-icon")!
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, [
          _createElementVNode("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "me-1" }, " Usuario ", -1)),
            _createVNode(_component_my_team_users_sort, { onColumnOrder: _ctx.updateSortConfiguration }, null, 8, ["onColumnOrder"])
          ])
        ]),
        _createElementVNode("th", null, [
          _createElementVNode("div", _hoisted_3, [
            _cache[11] || (_cache[11] = _createElementVNode("div", null, " ", -1)),
            _createVNode(_component_my_team_numeric_sort, {
              "low-label": "Menos a Más",
              "high-label": "Más a Menos",
              direction: _ctx.getColumnSortDirection('downlines'),
              onOrder: _cache[0] || (_cache[0] = 
                (direction) => _ctx.updateSortConfiguration('downlines', direction)
              )
            }, null, 8, ["direction"])
          ])
        ]),
        _createElementVNode("th", null, [
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex-grow-1 text-center" }, "Lado", -1)),
            _createVNode(_component_my_team_alpha_sort, {
              "low-label": "Izquierdo primero",
              "high-label": "Derecho primero",
              direction: _ctx.getColumnSortDirection('unilevel_side'),
              onOrder: _cache[1] || (_cache[1] = 
                (direction) => _ctx.updateSortConfiguration('unilevel_side', direction)
              )
            }, null, 8, ["direction"])
          ])
        ]),
        _createElementVNode("th", null, [
          _createElementVNode("div", _hoisted_5, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex-grow-1 text-center ps-2" }, "Paq", -1)),
            _createVNode(_component_my_team_numeric_sort, {
              "low-label": "De Go a Win",
              "high-label": "De Win a Go",
              direction: _ctx.getColumnSortDirection('current_package'),
              onOrder: _cache[2] || (_cache[2] = 
                (direction) => _ctx.updateSortConfiguration('current_package', direction)
              )
            }, null, 8, ["direction"])
          ])
        ]),
        _createElementVNode("th", null, [
          _createElementVNode("div", _hoisted_6, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-grow-1 text-center ps-2 th-icon" }, [
              _createElementVNode("i", {
                class: "far fa-calendar fa-fw",
                title: "Días Restantes"
              })
            ], -1)),
            _createVNode(_component_my_team_numeric_sort, {
              direction: _ctx.getColumnSortDirection('subscription_days_left'),
              onOrder: _cache[3] || (_cache[3] = 
                (direction) => _ctx.updateSortConfiguration('subscription_days_left', direction)
              )
            }, null, 8, ["direction"])
          ])
        ]),
        _createElementVNode("th", null, [
          _createElementVNode("div", _hoisted_7, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex-grow-1 text-center ps-2 th-icon" }, [
              _createElementVNode("i", {
                class: "fas fa-piggy-bank",
                title: "Beca"
              })
            ], -1)),
            _createVNode(_component_my_team_numeric_sort, {
              direction: _ctx.getColumnSortDirection('scholarship_points'),
              onOrder: _cache[4] || (_cache[4] = 
                (direction) => _ctx.updateSortConfiguration('scholarship_points', direction)
              )
            }, null, 8, ["direction"])
          ])
        ]),
        _createElementVNode("th", null, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_package_icon, {
                product: "license",
                label: "Licencia de Distribuidor"
              })
            ]),
            _createVNode(_component_my_team_numeric_sort, {
              direction: _ctx.getColumnSortDirection('distributor_days_left'),
              onOrder: _cache[5] || (_cache[5] = 
                (direction) => _ctx.updateSortConfiguration('distributor_days_left', direction)
              )
            }, null, 8, ["direction"])
          ])
        ]),
        _createElementVNode("th", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex-grow-1 text-center" }, "Volumen Calificado", -1)),
            _createVNode(_component_my_team_numeric_sort, {
              direction: _ctx.getColumnSortDirection('qualified_volume_total'),
              onOrder: _cache[6] || (_cache[6] = 
                (direction) => _ctx.updateSortConfiguration('qualified_volume_total', direction)
              )
            }, null, 8, ["direction"])
          ])
        ]),
        _createElementVNode("th", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex-grow-1 text-center" }, "% Calificado", -1)),
            _createVNode(_component_my_team_numeric_sort, {
              direction: _ctx.getColumnSortDirection('qualified_percentage_total'),
              onOrder: _cache[7] || (_cache[7] = 
                (direction) => _ctx.updateSortConfiguration('qualified_percentage_total', direction)
              )
            }, null, 8, ["direction"])
          ])
        ]),
        _createElementVNode("th", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex-grow-1 text-center" }, "Volumen Total", -1)),
            _createVNode(_component_my_team_numeric_sort, {
              direction: _ctx.getColumnSortDirection('total_volume'),
              onOrder: _cache[8] || (_cache[8] = 
                (direction) => _ctx.updateSortConfiguration('total_volume', direction)
              )
            }, null, 8, ["direction"])
          ])
        ]),
        _createElementVNode("th", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "flex-grow-1 text-center" }, "Profundidad", -1)),
            _createVNode(_component_my_team_numeric_sort, {
              direction: _ctx.getColumnSortDirection('depth'),
              onOrder: _cache[9] || (_cache[9] = 
                (direction) => _ctx.updateSortConfiguration('depth', direction)
              )
            }, null, 8, ["direction"])
          ])
        ])
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("td", {
              colspan: "11",
              class: "text-center pb-2"
            }, [
              _createElementVNode("i", { class: "fas fa-spinner fa-spin" }),
              _createTextVNode(" Cargando... ")
            ], -1)
          ]))]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.teamMembers, (entry, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `${entry._usernamePK}#${index}`
            }, [
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: ($event: any) => (_ctx.showUserTeam(entry._usernamePK)),
                      class: "avatar"
                    }, [
                      _createElementVNode("img", {
                        class: "avatar avatar-sm rounded-circle img-fluid border gtr-avatar-bg",
                        src: entry.profile_picture,
                        alt: entry.username
                      }, null, 8, _hoisted_23)
                    ], 8, _hoisted_22),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-dark fw-bold",
                          onClick: ($event: any) => (_ctx.showUserTeam(entry._usernamePK))
                        }, _toDisplayString(entry.nickname), 9, _hoisted_26),
                        _createElementVNode("a", {
                          href: "#",
                          class: "ps-2 text-dark",
                          onClick: ($event: any) => (_ctx.showUserTeam(entry._usernamePK))
                        }, _toDisplayString(entry.username), 9, _hoisted_27),
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_rank_icon, {
                            "icon-class": _ctx.rankIconClass(entry.current_rank),
                            "extra-class": "ps-2 pe-1 small"
                          }, null, 8, ["icon-class"]),
                          _createTextVNode(_toDisplayString(_ctx.rankName(entry.current_rank)), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("td", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "link-secondary small",
                    onClick: ($event: any) => (_ctx.showUserTeam(entry._usernamePK))
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-users me-1" }, null, -1)),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(entry.downlines), 1)
                  ], 8, _hoisted_31)
                ])
              ]),
              _createElementVNode("td", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.unilevelSideIconClass(entry.unilevel_side)),
                    title: _ctx.unilevelSideLabel(entry.unilevel_side)
                  }, null, 10, _hoisted_35),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.unilevelSideLabel(entry.unilevel_side)), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge rounded-pill border d-inline-flex align-items-center gap-1", _ctx.packageBadgeClass(entry.current_package)])
                  }, [
                    _createVNode(_component_package_icon, {
                      product: entry.current_package
                    }, null, 8, ["product"]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.packageLabel(entry.current_package)), 1)
                  ], 2)
                ])
              ]),
              _createElementVNode("td", _hoisted_39, [
                _createElementVNode("div", {
                  class: _normalizeClass(["badge rounded-pill", _ctx.daysLeftClass(entry.subscription_days_left || 0)])
                }, _toDisplayString((entry.subscription_days_left ?? 0).toLocaleString()), 3),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.formatDateTimezone(
                    new Date(entry.subscription_end_date).getTime()
                  ).substring(0, 10)), 1),
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.formatDateTimezone(
                    new Date(entry.subscription_end_date).getTime()
                  ).substring(11)), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_43, [
                (!_ctx.isLitePackage(entry.current_package))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (entry?.scholarship_points < 300)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fas fa-user align-middle", [
                      entry.scholarship_points >= 100
                        ? 'text-orange'
                        : 'text-light-gray',
                    ]])
                            }, null, 2),
                            _createElementVNode("i", {
                              class: _normalizeClass(["fas fa-user mx-1 align-middle", [
                      entry.scholarship_points >= 200
                        ? 'text-orange'
                        : 'text-light-gray',
                    ]])
                            }, null, 2),
                            _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-user text-light-gray align-middle" }, null, -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_45, [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("i", { class: "fas fa-award text-yellow fa-lg align-middle" }, null, -1)
                          ]))])),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.formatDateTimezone(
                      new Date(entry.scholarship_end_date).getTime()
                    ).substring(0, 10)), 1),
                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.formatDateTimezone(
                      new Date(entry.scholarship_end_date).getTime()
                    ).substring(11)), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_49, [
                (entry.distributor_days_left === null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("i", { class: "fas fa-times-circle text-red align-middle" }, null, -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["badge rounded-pill", _ctx.daysLeftClass(entry.distributor_days_left || 0)])
                    }, _toDisplayString(entry.distributor_days_left?.toLocaleString()), 3)),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.formatDateTimezone(
                    new Date(entry.distributor_end_date || 0).getTime()
                  ).substring(0, 10)), 1),
                  _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.formatDateTimezone(
                    new Date(entry.distributor_end_date || 0).getTime()
                  ).substring(11)), 1)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, _toDisplayString(entry.qualified_volume_total?.toLocaleString()), 1),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      (entry.qualified_volume_left_flag == 'MIN_TEAM')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("i", { class: "fas fa-exclamation text-danger" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", null, _toDisplayString(entry.qualified_volume_left?.toLocaleString()), 1),
                        _createElementVNode("div", _hoisted_60, _toDisplayString(entry.qualified_percentage_left) + " % ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", null, _toDisplayString(entry.qualified_volume_right?.toLocaleString()), 1),
                        _createElementVNode("div", _hoisted_63, _toDisplayString(entry.qualified_percentage_right) + " % ", 1)
                      ]),
                      (entry.qualified_volume_right_flag == 'MIN_TEAM')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("i", { class: "fas fa-exclamation text-danger" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, _toDisplayString(entry.qualified_percentage_total) + " %", 1)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, _toDisplayString(entry.total_volume?.toLocaleString()), 1),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      (entry.total_volume_left_flag == 'MAX_TEAM')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [...(_cache[27] || (_cache[27] = [
                            _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-sm text-warning" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_72, _toDisplayString(entry.total_volume_left?.toLocaleString()), 1)
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, _toDisplayString(entry.total_volume_right?.toLocaleString()), 1),
                      (entry.total_volume_right_flag == 'MAX_TEAM')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [...(_cache[28] || (_cache[28] = [
                            _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-sm text-warning" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("span", _hoisted_77, [
                    _createTextVNode(_toDisplayString(entry.depth) + " ", 1),
                    _cache[29] || (_cache[29] = _createElementVNode("span", null, [
                      _createElementVNode("i", {
                        class: "far fa-address-card fa-fw text-info",
                        title: "Uplines"
                      })
                    ], -1))
                  ])
                ])
              ])
            ]))
          }), 128))
    ])
  ]))
}